import React from 'react';
import PropTypes from 'prop-types';

import { get } from 'dpl/shared/utils/object';
import { makeSequence } from 'dpl/shared/utils';
import GenericSelect from 'dpl/components/GenericSelect';
import FullPageQuizQuestion from 'dpl/components/FullPageQuiz/FullPageQuizQuestion';

const INPUT_NAME = 'children_ages';
const AGE_OPTIONS = makeSequence(19).map((_, idx) => {
  if (idx === 0) {
    return {
      title: 'Under 1',
      value: 'under_one'
    };
  } else if (idx === 18) {
    return {
      title: '18+',
      value: 'eighteen_plus'
    };
  }

  return {
    title: `${idx}`,
    value: `${idx}`
  };
});

export default function QuizChildrenAgesQuestion({
  formState,
  handleNextClick,
  onChange,
  isValid
}) {
  const childrenCount = parseInt(get(formState, 'children_count'), 10);
  const childrenAges = get(formState, 'children_ages', []);

  return (
    <FullPageQuizQuestion
      className="mb10"
      handleNextClick={handleNextClick}
      icon="pram"
      isValid={isValid}
      title="How old are they?"
    >
      <ul className="nv4 flex justify-center flex-wrap flex-xl-nowrap">
        {Array.from(new Array(childrenCount), (_, idx) => {
          const id = `${INPUT_NAME}-${idx}`;
          const value = childrenAges[idx] || '';

          return (
            <li className="mh6 mh2-lg mv4" key={id}>
              <label htmlFor={id}>
                <p className="mb3 f4-md fw-medium">Child {idx + 1}</p>
                <GenericSelect
                  className="AdoptionApplicationQuizChildrenAgesQuestion__select f4-md fw-medium pv4 pv5-md br2 ba b--moon-gray"
                  arrowClassName="z-5 f1"
                  name={`${INPUT_NAME}.${idx}`}
                  onChange={onChange}
                  options={AGE_OPTIONS}
                  value={value}
                />
              </label>
            </li>
          );
        })}
      </ul>
    </FullPageQuizQuestion>
  );
}

QuizChildrenAgesQuestion.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  formState: PropTypes.object.isRequired,
  handleNextClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired
};
